import { ENTER } from '@angular/cdk/keycodes';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, OnChanges } from '@angular/core';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
  selector: 'autocomplete-chips',
  templateUrl: './autocomplete-chips.component.html',
  styleUrls: ['./autocomplete-chips.component.css']
})
export class AutocompleteChipsComponent<T> implements OnInit, OnChanges {
  @Input()
  public data: T[] = [];
  @Input()
  public publicVariable: string;
  @Input()
  public returnVariable: string;
  @Input()
  public label: string;
  @Input()
  public value: string[];
  @Output()
  public valueChange: EventEmitter<string[]>;

  public avalibleToAutocomplete: T[] = [];
  public visibleToAutocomplete: T[] = [];
  public selectedValues: T[] = [];

  public inputValue = '';
  public separatorKeysCodes: number[] = [ENTER];

  @ViewChild('input', { static: true }) fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto', { static: true }) matAutocomplete: MatAutocomplete;

  constructor() {
    this.valueChange = new EventEmitter();
  }

  ngOnInit() {}

  ngOnChanges() {
    this.avalibleToAutocomplete = [];
    this.selectedValues = [];
    this.data.forEach(d => {
      if (this.value.includes(d[this.returnVariable])) this.selectedValues.push(d);
      else this.avalibleToAutocomplete.push(d);
    });
    this.visibleToAutocomplete = this.avalibleToAutocomplete;
  }

  inputValueChange(value: string) {
    if (!value || !value.toString().trim().length) this.visibleToAutocomplete = this.avalibleToAutocomplete;
    this.visibleToAutocomplete = this.avalibleToAutocomplete.filter(v => {
      const variable: string = v[this.publicVariable];
      if (value.toString().includes(' ')) return variable.startsWith(value);
      return variable.split(' ').some(t => t.startsWith(value));
    });

    this.inputValue = value;
  }

  emitValue() {
    this.valueChange.emit(this.selectedValues.map(v => v[this.returnVariable]));
  }

  add(event: MatChipInputEvent): void {
    if (this.matAutocomplete.isOpen) return;

    const input = event.input;
    const value = event.value;

    if (!value || !value.length) return;

    const variable = this.avalibleToAutocomplete.findIndex(v => v[this.publicVariable].trim() === value.trim());
    if (variable !== -1) {
      this.selectedValues.push(this.avalibleToAutocomplete[variable]);
      this.avalibleToAutocomplete.splice(variable, 1);
    }

    if (input) input.value = '';
    this.inputValueChange('');
    this.emitValue();
  }

  remove(value: T): void {
    this.selectedValues = this.selectedValues.filter(v => v[this.returnVariable] !== value[this.returnVariable]);
    this.avalibleToAutocomplete.push(value);
    this.inputValueChange(this.inputValue);
    this.emitValue();
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const value = event.option.value;
    const variable = this.avalibleToAutocomplete.findIndex(v => v[this.returnVariable] === value);
    if (variable !== -1) {
      this.selectedValues.push(this.avalibleToAutocomplete[variable]);
      this.avalibleToAutocomplete.splice(variable, 1);
    }
    this.inputValueChange('');
    this.emitValue();
  }
}
